<template>
  <v-card>
    <v-card-title>{{$t('simulacion.modulo.ejecucion.titulo')}}</v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-container>
            <v-form v-model="valid" lazy-validation>

              <!--<v-container class="overflow-y-auto" style="max-height: 400px;">-->
              <v-container>                
<div class="contenedor-personalizado">
                <!-- Objetivo, Año de inicio y fin, etc.. -->
                <v-row>
                

                  
                    <v-col cols="4" sm="4">
                      <v-text-field    
                        density="compact"  
                        variant="outlined"                   
                        :label="$t('simulacion.modulo.ejecucion.anio_inicio')"
                        v-model.number="local_datos_generales.anio_inicio"
                        type="number"                        
                        :rules="[rules.required, rules.minYear]"
                        @blur="ajustarRango('anio_inicio'),  ajustarMes('solar'),  ajustarMes('eolica')"
                        class="wrap-label"
                      ></v-text-field>
                    </v-col>
                      <!-- mes de inicio -->
                  <v-col cols="4" sm="4">
                      <v-select     
                        density="compact"  
                        variant="outlined"
                        v-model.number="local_datos_generales.mes_inicio" 
                        :items="selec_meses"
                        item-value="ID"
                        item-title="NOMBRE"
                        :label="$t('simulacion.modulo.ejecucion.mes_inic')"   
                        @blur=" ajustarMes('solar'),  ajustarMes('eolica')"                  
                      ></v-select>
                    </v-col>
<!--
                    <v-col cols="3" sm="4">
                      <v-text-field
                        density="compact"  
                        variant="outlined" 
                        :label="$t('simulacion.modulo.ejecucion.anio_fin')"
                        v-model.number="local_datos_generales.anio_fin"
                        type="number"                        
                        :min="2023"
                        :max="2100"
                        @blur="ajustarRango('anio_fin')"
                        class="wrap-label"
                      ></v-text-field>
                    </v-col>-->
                  

                  <v-col cols="4" sm="4">
                    <v-text-field
                      density="compact"
                      variant="outlined"
                      :label="$t('simulacion.modulo.ejecucion.anio_ejec')" 
                      v-model.number="anio_ejec_local"
                      type="number"
                      min="1"
                      max="100"
                      :rules="[rules.required]"
                      class="wrap-label"
                     
                    ></v-text-field>
                    <!--  @input="recalcularAnioFin"  -->
                  </v-col>

                    
                  
                    
                </v-row>
                <v-row>
                  <!-- Año inicio de la solar -->
                  <v-col cols="4" sm="4" v-if="local_ejecucion.OPC_PV !== 0" >
                       <v-text-field 
                         
                        density="compact"  
                        variant="outlined"                   
                        :label="$t('simulacion.modulo.ejecucion.anio_inicio_solar')"
                        v-model.number="local_datos_generales.anio_inicio_solar"
                        type="number"                        
                        :rules="[rules.required, rules.maxYearCOD, rules.minYearCAPEX]"
                        @blur="ajustarRango('anio_inicio_solar',anio_inicio_capex,local_datos_generales.anio_inicio),ajustarMes('solar'),  ajustarMes('eolica')"
                        class="wrap-label"
                      ></v-text-field>

                  </v-col>
                     <v-col cols="4" sm="4" v-if="local_ejecucion.OPC_PV !== 0" >
                      <!-- Mes de inicio de la solar -->
                      <v-select     
                        density="compact"  
                        variant="outlined"
                        v-model.number="local_datos_generales.mes_inicio_solar" 
                        :items="selec_meses_solar"
                        item-value="ID"
                        item-title="NOMBRE"
                        :label="$t('simulacion.modulo.ejecucion.mes_inic_solar')"                  
                      ></v-select>
                      </v-col>         
                    </v-row>
                  <v-row>

                
                     <!-- Año de inicio de la eólica -->
                
                  <v-col cols="4" sm="4" v-if="local_ejecucion.OPC_EOL !== 0">
                       <v-text-field    
                       
                        density="compact"  
                        variant="outlined"                   
                        :label="$t('simulacion.modulo.ejecucion.anio_inicio_eolica')"
                        v-model.number="local_datos_generales.anio_inicio_eolica"
                        type="number"                        
                        :rules="[rules.required, rules.maxYearCOD, rules.minYearCAPEX]"
                        @blur="ajustarRango('anio_inicio_eolica',anio_inicio_capex,local_datos_generales.anio_inicio),  ajustarMes('solar'),  ajustarMes('eolica')"
                        class="wrap-label"
                      ></v-text-field>

                 
                    </v-col>
                  <v-col cols="4" sm="4" v-if="local_ejecucion.OPC_EOL !== 0 " >
                      <!-- Mes de inicio de la eolica -->
                      <v-select     
                        density="compact"  
                        variant="outlined"
                        v-model.number="local_datos_generales.mes_inicio_eolica" 
                        :items="selec_meses_eolica"
                        item-value="ID"
                        item-title="NOMBRE"
                        :label="$t('simulacion.modulo.ejecucion.mes_inic_eolica')"   
                                          
                      ></v-select>
                      </v-col>     
                  <v-col cols="4" sm="4"  >
                      <v-btn  :disabled="this.disabled" color="primary" style="min-height: 40px !important;"   class="wrap-label same-size text-wrap" @click="calcularAnio">
                        {{$t('comun.aplicar')}} 
                      </v-btn>
                    </v-col>
                 
            
                

                </v-row>
</div><br><br>
                    
<!--  @blur="ajustarRango('anio_fin')" -->
                  <!-- Separación de filas, tasa de descuento,Año inicio inflacion e inflacion anual  -->
                  <v-row>
                    <v-col cols="3" sm="3">
                      <v-text-field    
                        density="compact"  
                        variant="outlined"                   
                        :label="$t('simulacion.modulo.datos_economicos.anio_inicio_capex')"
                        v-model.number="anio_inicio_capex"
                        
                        type="number"                        
                         min="2000"
                        class="wrap-label"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="3" sm="3">
                      <v-text-field
                        density="compact"  
                        variant="outlined"                       
                        :label="$t('simulacion.modulo.ejecucion.TASA_DCTO')"
                        :model-value="formatNumber(local_ejecucion.TASA_DCTO * 100)"
                    @update:modelValue="val => updateNumberCampo(local_ejecucion, 'TASA_DCTO', val, true)"
                                        
                        :rules="[rules.Negativo]"                        
                        class="wrap-label"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="3" sm="3">
                      <v-text-field
                        density="compact"  
                        variant="outlined"                       
                        :label="$t('simulacion.modulo.ejecucion.INFL_COD')"
                        type="number"  
                        
                        :max="local_datos_generales.anio_inicio"
                        
                        v-model.number="local_ejecucion.INFL_COD"
                        @blur="ajustarRango('anio_inicio')"
                        
                        :rules="[rules.required, rules.maxYearCOD]"          
                        class="wrap-label"             
                      ></v-text-field>

              

                      
                    </v-col>
                    <v-col cols="3" sm="3">
                      

                      <v-text-field
                        density="compact"  
                        variant="outlined"                       
                        :label="$t('simulacion.modulo.ejecucion.TASA_INFL')"
                        :model-value="formatNumber(local_ejecucion.TASA_INFL * 100)"
    @update:modelValue="val => updateNumberCampo(local_ejecucion, 'TASA_INFL', val, true)"
                        
                        :rules="[]"           
                        class="wrap-label"             
                      ></v-text-field>
                    </v-col>
                    <!--
                    <v-col cols="2" sm="3">
                      

                      <v-select
                        density="compact"  
                        variant="outlined"                       
                        :label="$t('simulacion.modulo.ejecucion.OPC_AMORT')"
                        v-model.number="local_ejecucion.OPC_AMORT"
                        :items="amortizacion"
                        item-value="ID"
                        item-title="NOMBRE"            
                      ></v-select>
                    </v-col>

                    <v-col cols="3" sm="3">
                      <v-text-field
                        density="compact"  
                        variant="outlined"                       
                        :label="$t('simulacion.modulo.ejecucion.IMPTO_SOC')"
                         v-model.number="local_ejecucion.IMPTO_SOC"               
                        :rules="[rules.Negativo]"                        
                        class="wrap-label"
                      ></v-text-field>
                    </v-col>-->

                </v-row>
                 <div class="text-subtitle-1  font-weight-medium mb-2">{{$t('simulacion.modulo.ejecucion.subtitulo_horario')}}</div>
                 <v-divider  :thickness="3"  class= mb-8></v-divider>
                <v-row>
                  <v-col cols="3" sm="4" xl="4">
                    <v-select     
                        density="compact"  
                        variant="outlined"
                        v-model.number="h_ini" 
                        :items="horas.slice(0,h_fin+1)"
                        item-value="ID"
                        item-title="NOMBRE"
                        :label="formatLabel('h_ini')"  
                        class="wrap-label"                        
                      ></v-select>
                  </v-col>

                        <v-col cols="3" sm="4" xl="4" >
                          <v-select     
                              density="compact"  
                              variant="outlined"
                              v-model.number="h_fin" 
                              :items="horas_fin.slice(h_ini)"
                              item-value="ID"
                              item-title="NOMBRE"
                              :label="formatLabel('h_fin')" 
                              class="wrap-label"                         
                            ></v-select>
                        </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" sm="4">
                      <v-switch
                      density="compact"
                          rounded="sm"
                        v-model="usarSabado"
                        :label=" $t('simulacion.modulo.planta_electrolisis.sabado_l') "
                        inset
                        hide-details
                        color="blue"         
                        track-color="grey"
                        class="wrap-label"
                      />
                  </v-col>

                <v-col cols="3" sm="5">
                  <v-switch
                  density="compact"
                      rounded="sm"
                    v-model="usarDomingo"
                    :label=" $t('simulacion.modulo.planta_electrolisis.domingo_l') "
                    inset
                    hide-details
                    color="blue"         
                    track-color="grey"
                    class="wrap-label"
                  />
                </v-col>
                </v-row>
                    <v-divider :thickness="3" class= "mb-6 mt-4"></v-divider>
                <!-- OBJETIVO -->
                <v-row>
                    <v-col cols="6" sm="6">
                      <v-select     
                        density="compact"  
                        variant="outlined"
                        v-model.number="local_ejecucion.OPC_EJEC" 
                        :items="modos_ejecucion"
                        item-value="ID"
                        item-title="NOMBRE"
                        :label="$t('simulacion.modulo.ejecucion.OPC_EJEC')"                      
                      ></v-select>
                    </v-col>
                </v-row>                


                <!-- OPCIONES DE MERCADO -->
                <v-row>
                  <v-col cols="6" sm="6">
                    <v-select  
                      density="compact"  
                      variant="outlined"       
                      v-model.number="local_ejecucion.OPC_MCDO" 
                      :items="opciones_mercado"
                      item-value="ID"
                      item-title="NOMBRE"
                      :label="$t('simulacion.modulo.ejecucion.OPC_MCDO')"
                      @update:modelValue="onCambioDeMercado"
                    ></v-select>
                   </v-col>

                    <!-- <v-col cols="6" sm="6">
                      <v-text-field v-if="local_ejecucion.OPC_MCDO==1"
                        density="compact"  
                        variant="outlined" 
                        :label="$t('simulacion.modulo.ejecucion.LIMIT_MCDO')"
                        v-model.number="local_ejecucion.LIMIT_MCDO"
                        type="number"
                      ></v-text-field>
                  </v-col> -->
                </v-row>

                <!-- OPCIONES DE LA BATERIA 
                <v-row>
                  <v-col cols="6" sm="6">
                    <v-select  
                      density="compact"  
                      variant="outlined"       
                      v-model.number="local_ejecucion.OPC_EL" 
                      :items="opciones_bateria"
                      item-value="ID"
                      item-title="NOMBRE"
                      :label="$t('simulacion.modulo.ejecucion.OPC_BAT')" 
                    ></v-select>
                   </v-col>

                    <v-col cols="6" sm="6">
                    <v-text-field v-if="local_ejecucion.OPC_EL==0"
                      density="compact"  
                      variant="outlined"
                      :label="$t('simulacion.modulo.electrolizador.pelfija')"
                      v-model.number="local_electrolizador.pelfija"
                      type="number"
                    ></v-text-field>
               
                  </v-col>
                </v-row>
                -->

                <!-- OPCIONES DE ELECTROLIZADOR -->
                <v-row>
                  <v-col cols="6" sm="6">
                    <v-select  
                      density="compact"  
                      variant="outlined"       
                      v-model.number="local_ejecucion.OPC_EL" 
                      :items="opciones_electrolizador"
                      item-value="ID"
                      item-title="NOMBRE"
                      :label="$t('simulacion.modulo.ejecucion.OPC_EL')" 
                    ></v-select>
                   </v-col>

                    <v-col cols="6" sm="6">
                    <v-text-field v-if="local_ejecucion.OPC_EL==0"
                      density="compact"  
                      variant="outlined"
                      :label="$t('simulacion.modulo.electrolizador.pelfija')"
                      v-model.number="local_electrolizador.pelfija"
                      type="number"
                      :rules="[rules.Negativo]"
                    ></v-text-field>
               
                  </v-col>
                </v-row>

                <!-- OPCIONES DE ALMACENAMIENTO -->
                <v-row>
                  <v-col cols="6" sm="6">
                    <v-select  
                      density="compact"  
                      variant="outlined"       
                      v-model.number="local_ejecucion.OPC_ALM" 
                      :items="opciones_almacenamiento"
                      item-value="ID"
                      item-title="NOMBRE"
                      :label="$t('simulacion.modulo.ejecucion.OPC_ALM')"
                    ></v-select>
                   </v-col>

                    <v-col cols="6" sm="6">
                      <v-text-field v-if="local_ejecucion.OPC_ALM==1"
                        density="compact"  
                        variant="outlined"  
                        :label="$t('simulacion.modulo.almacenamiento.cmax')"
                        v-model.number="local_almacenamiento.cmax"
                        type="number"
                        :rules="[rules.Negativo]"
                      ></v-text-field>
                      <v-text-field v-if="local_ejecucion.OPC_ALM==2"
                        density="compact"  
                        variant="outlined"  
                        :label="$t('simulacion.modulo.almacenamiento.calmfija')"
                        v-model.number="local_almacenamiento.calmfija"
                        type="number"
                        :rules="[rules.Negativo]"
                      ></v-text-field>                      
                  </v-col>
                </v-row>


                <!-- OPCIONES DE LA BATERIA -->
                <v-row>
                  <v-col cols="6" sm="6">
                    <v-select  
                      density="compact"  
                      variant="outlined"       
                      v-model.number="local_ejecucion.OPC_BAT" 
                      :items="opciones_bateria"
                      item-value="ID"
                      item-title="NOMBRE"
                      :label="$t('simulacion.modulo.ejecucion.OPC_BAT')"
                    ></v-select>
                   </v-col>

                    <v-col cols="6" sm="6">
                      <v-text-field v-if="local_ejecucion.OPC_BAT==1"
                        density="compact"  
                        variant="outlined"  
                        :label="$t('simulacion.modulo.bateria.pmax')"
                        v-model.number="local_bateria.pmax"
                        type="number"
                        :rules="[rules.Negativo]"
                      ></v-text-field>
                      <v-text-field v-if="local_ejecucion.OPC_BAT==2"
                        density="compact"  
                        variant="outlined"  
                        :label="$t('simulacion.modulo.bateria.pbatfija')"
                        v-model.number="local_bateria.pbatfija"
                        type="number"
                        :rules="[rules.Negativo]"
                      ></v-text-field>                      
                  </v-col>
                </v-row>

                
                <v-row v-if="local_ejecucion.OPC_BAT>0 && 'OPC_VBAT' in local_ejecucion ">
                  <v-col cols="6" sm="6">
                    <v-switch 
                      density="compact"  
                      variant="outlined"       
                      v-model.number="local_ejecucion.OPC_VBAT " 
                      :true-value="1"
                      :false-value="0"
                      :label="$t('simulacion.modulo.ejecucion.OPC_VBAT')"
                      inset  color="blue" track-color="grey"
                    />
                   </v-col>

                   <v-col cols="6" sm="6">
                    <v-text-field v-if="local_ejecucion.OPC_VBAT==1"
                        density="compact"  
                        variant="outlined"  
                        :label="$t('simulacion.modulo.bateria.poiv')"
                        v-model.number="local_bateria.poiv"
                        type="number"
                        :rules="[rules.Negativo]"
                      ></v-text-field>
                   </v-col>
                </v-row>


                <!-- OPCIONES DE FOTOVOLTAICA -->
                <v-row>

                  <v-col cols="4" sm="4">
                    <v-select      
                      density="compact"  
                      variant="outlined"                       
                      v-model.number="local_ejecucion.OPC_PV" 
                      :items="opciones_fotovoltaica"
                      item-value="ID"
                      item-title="NOMBRE"
                      :label="$t('simulacion.modulo.ejecucion.OPC_PV')"       
                       @update:modelValue="$emit('descargar_precios');"               
                    ></v-select>
                  </v-col>

                    <v-col cols="4" sm="4">
                      <v-text-field v-if="local_ejecucion.OPC_PV==1"
                        density="compact"  
                        variant="outlined"  
                        :label="$t('simulacion.modulo.fotovoltaica.pmax')"
                        v-model.number="local_fotovoltaica.pmax"
                        type="number"
                        :rules="[rules.Negativo]"
                      ></v-text-field>
                      <v-text-field v-if="local_ejecucion.OPC_PV==2"
                        density="compact"  
                        variant="outlined"  
                        :label="$t('simulacion.modulo.fotovoltaica.ppvfija')"
                        v-model.number="local_fotovoltaica.ppvfija"
                        type="number"
                        :rules="[rules.Negativo]"
                      ></v-text-field>                      
                    </v-col>
                    <v-col cols="4" sm="4" v-if="local_ejecucion.OPC_PV !== 0 && local_ejecucion.OPC_MCDO !== 3">
                      <v-switch
                      :model-value="usarFVfija"
                      @update:modelValue="$emit('update:usarFVfija', $event)"
                        v-model.number="local_ejecucion.OPC_PCPPAPV"
                        :label="$t('simulacion.modulo.ejecucion.FV_FIJA')"
                        :true-value="1"
                        :false-value="0"
                        inset hide-details color="blue" track-color="grey"
                      />
                    </v-col>
                  <!--  <v-col cols="4" sm="4">
                    <v-text-field v-if="local_ejecucion.OPC_PCPPAPV == 1"
                      density="compact"
                      variant="outlined"
                      :label="$t('simulacion.modulo.ejecucion.pcppapv')"
                      v-model.number="local_fotovoltaica.pcppapv"
                      type="number"
                      :rules="[rules.required, rules.Negativo]"
                      
                    ></v-text-field>
                    </v-col>-->

                </v-row>

                <!-- OPCIONES DE EOLICA -->
                <v-row>
                  <v-col cols="4" sm="4">
                    <v-select      
                      density="compact"  
                      variant="outlined"   
                      v-model.number="local_ejecucion.OPC_EOL" 
                      :items="opciones_eolica"
                      item-value="ID"
                      item-title="NOMBRE"
                      :label="$t('simulacion.modulo.ejecucion.OPC_EOL')"
                       @update:modelValue="$emit('descargar_precios');"
                    ></v-select>
                  </v-col>

                    <v-col cols="4" sm="4">
                      <v-text-field v-if="local_ejecucion.OPC_EOL==1"
                        density="compact"  
                        variant="outlined"  
                        :label="$t('simulacion.modulo.eolica.pmax')"
                        v-model.number="local_eolica.pmax"
                        type="number"
                        :rules="[rules.Negativo]"
                      ></v-text-field>
                      <v-text-field v-if="local_ejecucion.OPC_EOL==2"
                        density="compact"  
                        variant="outlined"  
                        :label="$t('simulacion.modulo.eolica.peolfija')"
                        v-model.number="local_eolica.peolfija"
                        type="number"
                        :rules="[rules.Negativo]"
                      ></v-text-field>                      
                    </v-col>
                    <v-col cols="4" sm="4" v-if="local_ejecucion.OPC_EOL !== 0 && local_ejecucion.OPC_MCDO !== 3">
                      <v-switch
                      :model-value="usarEOfija"
                      @update:modelValue="$emit('update:usarEOfija', $event)"
                        v-model.number="local_ejecucion.OPC_PCPPAEOL"
                        :label="$t('simulacion.modulo.ejecucion.EO_FIJA')"
                        :true-value="1"
                        :false-value="0"
                        inset hide-details color="blue" track-color="grey"
                      />
                    </v-col>
                    
                  <!--  <v-col cols="4" sm="4">
                    <v-text-field v-if="local_ejecucion.OPC_PCPPAEOL == 1"
                    density="compact"
                    variant="outlined"
                    :label="$t('simulacion.modulo.ejecucion.pcppaeol')"
                    v-model.number="local_eolica.pcppaeol"
                    type="number"
                    :rules="[rules.required, rules.Negativo]"
                  ></v-text-field>
                  </v-col>-->

                </v-row>

                <!-- OPCIONES DE GENERACION -->
                
                <v-row v-if="local_ejecucion.OPC_MCDO !== 3">
                  <!-- Selector: Optimizar vs Fija -->
                  <v-col cols="6" sm="6">
                    <v-select
                      density="compact"
                      variant="outlined"
                      v-model.number="local_ejecucion.OPC_POIC"
                      :items="opciones_poic"
                      item-value="ID"
                      item-title="NOMBRE"
                      :label="$t('simulacion.modulo.gen.opc_poic')"  
                    />
                  </v-col>

                  <!-- Precio potencia de acceso de compra (EUR/MW) -> dat_gen.dat : pcpoic 
                  <v-col cols="6" sm="6">
                    <v-text-field
                      density="compact"
                      variant="outlined"
                      :label="$t('simulacion.modulo.gen.pcpoic')"  
                      v-model.number="local_gen.pcpoic"
                      type="number"
                      :rules="[rules.Negativo]"
                    />
                  </v-col>-->
                </v-row>

                <!-- Si se OPTIMIZA: mostrar poicmin / poicmax -->
                <v-row v-if="local_ejecucion.OPC_MCDO !== 3 && local_ejecucion.OPC_POIC === 1">
                  <v-col cols="6" sm="6">
                    <v-text-field
                      density="compact"
                      variant="outlined"
                      :label="$t('simulacion.modulo.gen.poicmin')"  
                      v-model.number="local_gen.poicmin"
                      type="number"
                      :rules="[rules.Negativo]"
                    />
                  </v-col>
                  <v-col cols="6" sm="6">
                    <v-text-field
                      density="compact"
                      variant="outlined"
                      :label="$t('simulacion.modulo.gen.poicmax')"  
                      v-model.number="local_gen.poicmax"
                      type="number"
                      :rules="[rules.Negativo]"
                    />
                  </v-col>
                </v-row>

                <!-- Si es FIJA: mostrar poicfij -->
                <v-row v-if="local_ejecucion.OPC_MCDO !== 3 && local_ejecucion.OPC_POIC === 0">
                  <v-col cols="6" sm="6">
                    <v-text-field
                      density="compact"
                      variant="outlined"
                      :label="$t('simulacion.modulo.gen.poicfij')"  
                      v-model.number="local_gen.poicfij"
                      type="number"
                      :rules="[rules.Negativo]"
                    />
                  </v-col>
                </v-row>
               <!--   <v-col cols="6" sm="6">
                    <v-text-field
                      density="compact"  
                      variant="outlined"  
                      :label="$t('simulacion.modulo.gen.poiv')"
                      v-model.number="local_gen.poiv"
                      type="number"
                      :rules="[rules.Negativo]"
                    ></v-text-field>
                  </v-col>-->
                
                <v-row
                    v-if="
                      local_ejecucion.OPC_MCDO !== 3 &&
                      local_ejecucion.OPC_PV !== 0 &&
                      local_ejecucion.OPC_EOL !== 0
                    "
                  >
                    <v-col cols="6" sm="6">
                      <v-switch 
                        v-model.number="local_ejecucion.OPC_POIV_RES_CONJUNTA"
                        :label="$t('simulacion.modulo.gen.poiv_res_conjunta')"
                        :true-value="1"
                        :false-value="0"
                        inset
                        hide-details
                        color="blue"
                        track-color="grey"
                      />
                    </v-col>
                  </v-row>

                  <v-row
                    v-if="
                      local_ejecucion.OPC_MCDO !== 3 &&
                      local_ejecucion.OPC_PV !== 0 &&
                      local_ejecucion.OPC_EOL !== 0 &&
                      local_ejecucion.OPC_POIV_RES_CONJUNTA === 1
                    "
                  >
                    <v-col cols="6" sm="6">
                      <v-text-field
                        density="compact"
                        variant="outlined"
                        :label="$t('simulacion.modulo.gen.poiv_res')"
                        v-model.number="local_gen.poiv"
                        type="number"
                        :rules="[rules.Negativo]"
                      />
                    </v-col>
                  </v-row>

                  <v-row
                    v-if="
                      local_ejecucion.OPC_MCDO !== 3 &&
                      local_ejecucion.OPC_POIV_RES_CONJUNTA === 0
                    "
                  >
                    <v-col cols="6" sm="6" v-if="local_ejecucion.OPC_PV !== 0">
                      <v-text-field
                        density="compact"
                        variant="outlined"
                        :label="$t('simulacion.modulo.gen.poiv_pv_venta')"
                        v-model.number="local_fotovoltaica.poiv"
                        type="number"
                        :rules="[rules.Negativo]"
                      />
                    </v-col>

                    <v-col cols="6" sm="6" v-if="local_ejecucion.OPC_EOL !== 0">
                      <v-text-field
                        density="compact"
                        variant="outlined"
                        :label="$t('simulacion.modulo.gen.poiv_eol_venta')"
                        v-model.number="local_eolica.poiv"
                        type="number"
                        :rules="[rules.Negativo]"
                      />
                    </v-col>
                  </v-row>



                <!-- OPCIONES DE PPA -->
                <v-row v-if="local_ejecucion.OPC_MCDO !== 3">
                  <v-col cols="6" sm="6">
                    <v-select      
                      density="compact"  
                      variant="outlined"   
                      v-model.number="local_ejecucion.OPC_PPA" 
                      :items="opciones_ppas"
                      item-value="ID"
                      item-title="NOMBRE"
                      :label="$t('simulacion.modulo.ejecucion.OPC_PPA')"
                    ></v-select>

                    <v-switch   v-if="local_ejecucion.OPC_PPA !== 0"                   
                      v-model.number="local_ejecucion.OPC_PCPPA"
                      :label="local_ejecucion.OPC_PCPPA === 1 ? 'Precio fijo venta PPAs' : 'Precio fijo venta PPAs'"                      
                      inset hide-details color="blue" track-color="grey"
                      :true-value="1"
                      :false-value="0"
                    />

                  </v-col>

                  <v-col cols="6" sm="6" v-if="local_ejecucion.OPC_PPA==2">
                    <v-data-table 
                        density="compact"  
                        variant="outlined"  
                        :headers="headers"
                        :items="local_ppa_configuracion"
                        item-value="tipo"
                        class="elevation-1"
                        hide-default-footer
                      >

                        <template v-slot:[`item.cppafija`]="{ item }">
                          <v-text-field
                            density="compact"  
                            variant="outlined"
                            v-model.number="item.cppafija"      
                            type="number"                                              
                            @input="emitChanges"
                            :rules="[rules.Negativo]"
                          ></v-text-field>
                        </template>
                    </v-data-table>
                  </v-col>

                  <v-col cols="6" sm="6" v-if="local_ejecucion.OPC_PPA==1">
                    <v-data-table 
                        density="compact"  
                        variant="outlined"  
                        :headers="headers_ppa_capmax"
                        :items="local_ppa_configuracion"
                        item-value="tipo"
                        class="elevation-1"
                        hide-default-footer
                      >

                        <template v-slot:[`item.capmax`]="{ item }">
                          <v-text-field
                            density="compact"  
                            variant="outlined"
                            v-model.number="item.capmax"      
                            type="number"                                              
                            @input="emitChanges"
                            :rules="[rules.Negativo]"
                          ></v-text-field>
                        </template>
                    </v-data-table><br><br>
                  </v-col>

                  <!-- Años PPA -->
                <v-row v-if="local_ejecucion.OPC_PPA !== 0 && local_ejecucion.ANIO_PPA_INI && local_ejecucion.ANIO_PPA_FIN">
                  <v-col cols="6" sm="6">
                    <v-text-field
                      ref="refAnioPpaIni"
                      density="compact"
                      variant="outlined"
                      :label="$t('simulacion.modulo.ejecucion.ANIO_PPA_INI')"
                      v-model.number="ANIO_PPA_INI"
                      type="number"
                      :rules="[
                        rules.required,
                        v => v >= local_datos_generales.anio_inicio || `≥ ${local_datos_generales.anio_inicio}`,
                        v => v <= (local_ejecucion.ANIO_PPA_FIN ?? local_datos_generales.anio_fin) || 'No puede ser mayor que año fin'
                      ]"
                    />
                  </v-col>

                  <v-col cols="6" sm="6">
                    <v-text-field
                      ref="refAnioPpaFin"
                      density="compact"
                      variant="outlined"
                      :label="$t('simulacion.modulo.ejecucion.ANIO_PPA_FIN')"
                      v-model.number="ANIO_PPA_FIN"
                      type="number"
                      :rules="[
                        rules.required,
                        v => v <= local_datos_generales.anio_fin || `≤ ${local_datos_generales.anio_fin}`,
                        v => v >= (local_ejecucion.ANIO_PPA_INI ?? local_datos_generales.anio_inicio) || 'No puede ser menor que año inicio'
                      ]"
                    />
                  </v-col>
                </v-row>


                </v-row>

                <!-- OPCIONES DE DUCTO, CONEXIÓN, TT -->
                <v-row>
                <v-col cols="4">
                  <!-- Ducto -->
                  <v-switch
                    :model-value="usarDucto"
                    @update:modelValue="$emit('update:usarDucto', $event)"
                    :label="$t('simulacion.modulo.ejecucion.switch.ducto')"
                    inset hide-details color="blue" track-color="grey"
                  />
                </v-col>
                <v-col cols="4">
                  <v-tooltip v-if="local_ejecucion.OPC_MCDO === 3" location="top">
                    <template v-slot:activator="{ props }">
                      <div v-bind="props">
                        <!-- Conexión eléctrica 
                        <v-switch
                          :model-value="usarConexion"
                          disabled
                          :label="$t('simulacion.modulo.ejecucion.switch.conexion')"
                          inset hide-details color="blue" track-color="grey"
                        />-->
                      </div>
                    </template>
                    <span>"{{$t('simulacion.modulo.ejecucion.switch.span')}}</span>
                  </v-tooltip>
                  <!-- Conexión electrica (else) 
                  <v-switch
                    v-else
                    :model-value="usarConexion"
                    @update:modelValue="$emit('update:usarConexion', $event)"
                    :label="$t('simulacion.modulo.ejecucion.switch.conexion')"
                    inset hide-details color="blue" track-color="grey"
                  />-->
                </v-col>
                <v-col cols="4">
                  <!-- tube-trailers -->
                  <v-switch
                    :model-value="usarTube"
                    @update:modelValue="$emit('update:usarTube', $event)"
                    :label="$t('simulacion.modulo.ejecucion.switch.tt')"
                    inset hide-details color="blue" track-color="grey"
                  />
                </v-col>
              </v-row>

                <!-- OPCIONES DE DEMANDA -->
                              
              <v-row>
                <v-col cols="4" sm="4">
                  <v-switch
                    v-model.number="local_ejecucion.OPCDEM_A"
                    :label="$t('simulacion.modulo.ejecucion.OPCDEM_A')"
                    :true-value="1"
                    :false-value="0"
                    inset hide-details color="blue" track-color="grey"
                  />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-switch
                    v-model.number="local_ejecucion.OPCDEM_M"
                    :label="$t('simulacion.modulo.ejecucion.OPCDEM_M')"
                    :true-value="1"
                    :false-value="0"
                    inset hide-details color="blue" track-color="grey"
                  />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-switch
                    v-model.number="local_ejecucion.OPCDEM_D"
                    :label="$t('simulacion.modulo.ejecucion.OPCDEM_D')"
                    :true-value="1"
                    :false-value="0"
                    inset hide-details color="blue" track-color="grey"
                  />
                </v-col>
              </v-row>



              </v-container>


            </v-form>
          </v-container>
        </v-col>
      </v-row>

      

    </v-card-text>
  </v-card>
</template>

<script>
//import Swal from "sweetalert2";
export default {

emits: [
    // lo que realmente emites desde el componente:
    'update:planta_electrolisis',
    'update:usarEOfija',
  'update:usarFVfija',
  'descargar_precios'

    ],
  props: {
    ejecucion: {
      type: Object,
      required: true,
    },
    datos_generales: {
      type: Object,
      required: true,
    },
    electrolizador: {
      type: Object,
      required: true,
    },
    almacenamiento: {
      type: Object,
      required: true,
    },
    bateria: {
      type: Object,
      required: true,
    },
    ppa_configuracion: {
      type: Array,
      required: true,
    },
    gen: {
      type: Object,
      required: true,
    },
    eolica: {
      type: Object,
      required: true,
    },
    fotovoltaica: {
      type: Object,
      required: true,
    },
    datos_economicos:{
      type:Object,
      required:true,

    },
    id_simulacion: {
    type: [String, Number],
    default: null
  },
  planta_electrolisis:{
    type:Object,
    default:null,
  },
  usarDucto: Boolean,
  usarConexion: Boolean,
  usarTube: Boolean,
  usarEOfija: { type: [Number, Boolean, String], default: 0 },
  usarFVfija: { type: [Number, Boolean, String], default: 0 },
  precioPPA: {
      type:Boolean,
      default:true,
    },
  },
  
  data() {
    return {
      
      valid: false,
      //local_ejecucion: { ...this.ejecucion },     

      
      local_datos_generales: { ...this.datos_generales},         
      local_electrolizador: { ...this.electrolizador},  
      local_almacenamiento: { ...this.almacenamiento},  
      local_bateria: { ...this.bateria},  
      local_ppa_configuracion: [...this.ppa_configuracion],  
      local_ejecucion: {
        OPC_POIV_RES_CONJUNTA: 0,
        ...this.ejecucion
      },
      local_gen: {
        poiv: 0,
        ...this.gen
      }, 
      local_eolica: { ...this.eolica}, 
      local_fotovoltaica: { ...this.fotovoltaica}, 
      datos:{...this.planta_electrolisis},
      horas: [
          { ID: 0, NOMBRE: '00:00H' },
          { ID: 1, NOMBRE: '01:00H' },
          { ID: 2, NOMBRE: '02:00H' },
          { ID: 3, NOMBRE: '03:00H' },
          { ID: 4, NOMBRE: '04:00H' },
          { ID: 5, NOMBRE: '05:00H' },
          { ID: 6, NOMBRE: '06:00H' },
          { ID: 7, NOMBRE: '07:00H' },
          { ID: 8, NOMBRE: '08:00H' },
          { ID: 9, NOMBRE: '09:00H' },
          { ID: 10, NOMBRE: '10:00H' },
          { ID: 11, NOMBRE: '11:00H' },
          { ID: 12, NOMBRE: '12:00H' },
          { ID: 13, NOMBRE: '13:00H' },
          { ID: 14, NOMBRE: '14:00H' },
          { ID: 15, NOMBRE: '15:00H' },
          { ID: 16, NOMBRE: '16:00H' },
          { ID: 17, NOMBRE: '17:00H' },
          { ID: 18, NOMBRE: '18:00H' },
          { ID: 19, NOMBRE: '19:00H' },
          { ID: 20, NOMBRE: '20:00H' },
          { ID: 21, NOMBRE: '21:00H' },
          { ID: 22, NOMBRE: '22:00H' },
          { ID: 23, NOMBRE: '23:00H' },
        ],
        horas_fin: [
          { ID: 0, NOMBRE: '01:00H' },
          { ID: 1, NOMBRE: '02:00H' },
          { ID: 2, NOMBRE: '03:00H' },
          { ID: 3, NOMBRE: '04:00H' },
          { ID: 4, NOMBRE: '05:00H' },
          { ID: 5, NOMBRE: '06:00H' },
          { ID: 6, NOMBRE: '07:00H' },
          { ID: 7, NOMBRE: '08:00H' },
          { ID: 8, NOMBRE: '09:00H' },
          { ID: 9, NOMBRE: '10:00H' },
          { ID: 10, NOMBRE: '11:00H' },
          { ID: 11, NOMBRE: '12:00H' },
          { ID: 12, NOMBRE: '13:00H' },
          { ID: 13, NOMBRE: '14:00H' },
          { ID: 14, NOMBRE: '15:00H' },
          { ID: 15, NOMBRE: '16:00H' },
          { ID: 16, NOMBRE: '17:00H' },
          { ID: 17, NOMBRE: '18:00H' },
          { ID: 18, NOMBRE: '19:00H' },
          { ID: 19, NOMBRE: '20:00H' },
          { ID: 20, NOMBRE: '21:00H' },
          { ID: 21, NOMBRE: '22:00H' },
          { ID: 22, NOMBRE: '23:00H' },
          { ID: 23, NOMBRE: '00:00H' },
        ],

      //local_economicos:{...this.datos_economicos},
      
      rules: {
        required: (v) => !!v || "Este campo es obligatorio",
        minYear: (value) => value >= this.min_year || `El año debe ser mayor o igual a ${this.min_year}`,
        maxYearCOD:(value) => value <= this.local_datos_generales.anio_inicio || `El año debe ser menor o igual a ${this.local_datos_generales.anio_inicio}`,
        minYearCAPEX:(value) => value >= this.anio_inicio_capex || `El año debe ser mayor o igual a ${this.anio_inicio_capex}`,
        Negativo: (v) => {
        const num = Number(v.toString().replace(',', '.'));
          return isNaN(num) ? 'Valor inválido' : (num >= 0 ? true : 'El valor no puede ser negativo');
        },
},
      modos_ejecucion: [
        {'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.lcoh_min')},
        {'ID': 2, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.npv_max')},
      ],
      /*amortizacion: [
         {'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.OPC_AMORT_si')},
         {'ID': 0, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.OPC_AMORT_no')},
      ],*/
      selec_meses:[
      { ID: 1,  NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.enero') },
      { ID: 2,  NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.febrero') },
      { ID: 3,  NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.marzo') },
      { ID: 4,  NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.abril') },
      { ID: 5,  NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.mayo') },
      { ID: 6,  NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.junio') },
      { ID: 7,  NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.julio') },
      { ID: 8,  NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.agosto') },
      { ID: 9,  NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.septiembre') },
      { ID: 10, NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.octubre') },
      { ID: 11, NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.noviembre') },
      { ID: 12, NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.diciembre') },
      ],

      opciones_mercado: [
        //{'ID': 0, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.no_limit')},
        {'ID': 0, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.compra_mercado')},
        //{'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.price_limit')},
        //{'ID': 2, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.buy_aux')},
        {'ID': 3, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.off_grid')},
      ],

      opciones_bateria: [
        {'ID': 0, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.no_bat')},
        {'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.opt_bat')},
        {'ID': 2, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.bat_fix_cap')},
      ],

      opciones_venta_bateria: [
        {'ID': 0, 'NOMBRE': this.$t('comun.no')},
        {'ID': 1, 'NOMBRE': this.$t('comun.si')},
        
      ],


      opciones_fotovoltaica: [
        {'ID': 0, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.no_pv')},
        {'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.opt_pv')},
        {'ID': 2, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.pv_fix_cap')},
      ],

      opciones_eolica: [
        {'ID': 0, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.no_eol')},
        {'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.opt_eol')},
        {'ID': 2, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.eol_fix_cap')},
      ],


      opciones_almacenamiento: [
        {'ID': 0, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.no_alm')},
        {'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.opt_alm')},
        {'ID': 2, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.alm_fix')},
      ],

      opciones_electrolizador: [
        {'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.opt_elec')},
        {'ID': 0, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.elec_fix')},
      ],

      opciones_ppas: [
        {'ID': 0, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.no_ppas')},
        {'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.opt_ppas')},
        {'ID': 2, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.ppas_fix')},
      ],
      opciones_poic: [
        { ID: 1, NOMBRE: this.$t('simulacion.modulo.gen.opc_poic_opt') }, // 'Optimizar potencia de acceso de compra'
        { ID: 0, NOMBRE: this.$t('simulacion.modulo.gen.opc_poic_fix') }, // 'Potencia de acceso de compra fija'
      ],
      headers: [
        { title: this.$t('simulacion.modulo.ejecucion.tabla.ppa'), value: "ppa", align: "start", width: '10%' },
        { title: this.$t('simulacion.modulo.ejecucion.tabla.cppafija'), value: "cppafija", align: "center", width: '20%' },
      ],

      headers_ppa_capmax: [
        { title: this.$t('simulacion.modulo.ejecucion.tabla.ppa'), value: "ppa", align: "start", width: '10%' },
        { title: this.$t('simulacion.modulo.ppa_configuracion.capmax'), value: "capmax", align: "center", width: '20%' },
      ],



    };
  },

  computed: {
    selec_meses_solar:{
      get(){
        if(this.local_datos_generales.anio_inicio=== this.local_datos_generales.anio_inicio_solar){

            this.ajustarMes("solar")
            return this.selec_meses.slice(0,this.local_datos_generales.mes_inicio)
         }
         else{
          return this.selec_meses
         }
      }
    },
    selec_meses_eolica:{
      get(){
        if(this.local_datos_generales.anio_inicio=== this.local_datos_generales.anio_inicio_eolica){

            this.ajustarMes("eolica")
            return this.selec_meses.slice(0,this.local_datos_generales.mes_inicio)
         }
         else{
          return this.selec_meses
         }
      }
    },
    h_ini: {
  get() { return this.datos.h_ini },
  set(val) {
    //console.log("Val: ", val)
    val=Number(val)
    this.datos.h_ini =val;
    
  }
},
 h_fin: {
  get() { return this.datos.h_fin },
  set(val) {
    //console.log("Val Fin: ", val)
    val=Number(val)
    this.datos.h_fin = val;
  }
},
  usarSabado: {
      get() {
        return this.datos.sabado_l=== 1
      },
      set(val) {
        console.log("Nuevo valor: ", val)
        this.datos.sabado_l= (val)? 1:0;
        
      }
    },
    usarDomingo: {
      get() {
        return this.datos.domingo_l=== 1
      },
      set(val) {
        console.log("Nuevo valor: ", val)
        this.datos.domingo_l= (val)? 1:0;
        
      }
    },
    /* anio_ejec: {
    get() {
      return this.local_datos_generales.anio_fin - this.local_datos_generales.anio_inicio;
    },
    set(nuevaCantidad) {
      const duracion = parseInt(nuevaCantidad);
      if (!isNaN(duracion)) {
        this.local_datos_generales.anio_fin = this.local_datos_generales.anio_inicio + duracion;
      }
    }
  },*/
   anio_ejec_local: {
    get() {
      if (this.local_datos_generales.mes_inicio==1){
        return this.local_datos_generales.anio_fin - this.local_datos_generales.anio_inicio+1;
      }
      console.log("GET ANIO EJEC LOCAL")
      return this.local_datos_generales.anio_fin - this.local_datos_generales.anio_inicio;
    },
    set(value) {
      console.log("SET de anio ejec local")
      let duracion = parseInt(value);
      if (this.local_datos_generales.mes_inicio==1){
        duracion-=1
      }
      if (!isNaN(duracion)) {
 
        let nuevoFin = this.local_datos_generales.anio_inicio + duracion;
        console.log("Nuevo fin: ", nuevoFin)
        if (nuevoFin > 2100) {
          nuevoFin = 2100;
          this.local_datos_generales.anio_fin = 2100;
        } else {
          this.local_datos_generales.anio_fin = nuevoFin;
        }
      }this.$emit('actualizar-an-tot', parseInt(value) || 0);
    }
  },

    anio_inicio_capex: {
    get() {
      return this.datos_economicos.anio_inicio_capex;
    },
    set(val) {
      //console.log("Nuevo val: ", val)
      const nuevo = {
        ...this.datos_economicos,
        anio_inicio_capex: val
      };
      //Autoajustar los años de inicio de la eólica y de la solar
      if(this.local_datos_generales.anio_inicio_eolica<val){
        this.local_datos_generales.anio_inicio_eolica=val
      }
      if(this.local_datos_generales.anio_inicio_solar<val){
        this.local_datos_generales.anio_inicio_solar=val
      }
        if (val>2000){
          this.$emit('update:datos_economicos', nuevo);
        }
    }
  },
    min_year() {
    return new Date().getFullYear();
    },
    TASA_DCTO: {
      get() {        
        const value = this.local_ejecucion.TASA_DCTO  
        return (value * 100).toFixed(2)               
      },
      set(value) {        
        const numericValue = value / 100;
        this.local_ejecucion.TASA_DCTO = isNaN(numericValue) ? 0 : numericValue;
      },
    },

    TASA_INFL: {
      get() {        
        const value = this.local_ejecucion.TASA_INFL  
        return (value * 100).toFixed(2)               
      },
      set(value) {        
        const numericValue = value / 100;
        this.local_ejecucion.TASA_INFL = isNaN(numericValue) ? 0 : numericValue;
      },
    },

    ANIO_PPA_INI: {
    get() {
      return this.local_ejecucion.ANIO_PPA_INI ?? this.local_datos_generales.anio_inicio
    },
    set(val) {
      this.local_ejecucion.ANIO_PPA_INI = val
    }
  },
  ANIO_PPA_FIN: {
    get() {
      return this.local_ejecucion.ANIO_PPA_FIN ?? this.local_datos_generales.anio_fin
    },
    set(val) {
      this.local_ejecucion.ANIO_PPA_FIN = val
    }
  }
  },
  

  watch: {    
    'local_datos_generales.anio_inicio'() {
  this.$nextTick(() => {
    const anTot = parseInt(this.anio_ejec_local, 10) || 1;
    this.$emit('actualizar-an-tot', anTot);
    this.$refs.refAnioPpaIni?.validate();
      this.$refs.refAnioPpaFin?.validate();
        //Autoajustar los años de inicio de la eólica y de la solar
      if(this.local_datos_generales.anio_inicio_eolica>this.local_datos_generales.anio_inicio){
        console.log("Eolica mayor que value")
        this.local_datos_generales.anio_inicio_eolica=this.local_datos_generales.anio_inicio
      }
      if(this.local_datos_generales.anio_inicio_solar>this.local_datos_generales.anio_inicio){
        this.local_datos_generales.anio_inicio_solar=this.local_datos_generales.anio_inicio
      }

      
  });
},
'local_datos_generales.anio_fin'() {
  this.$nextTick(() => {
    const anTot = parseInt(this.anio_ejec_local, 10) || 1;
    this.$emit('actualizar-an-tot', anTot);
    this.$refs.refAnioPpaIni?.validate();
      this.$refs.refAnioPpaFin?.validate();
  });
},
'local_datos_generales.mes_inicio'() {
  this.$nextTick(() => {
    const anTot = parseInt(this.anio_ejec_local, 10) || 1;
    this.$emit('actualizar-an-tot', anTot);
  });
},
'local_ejecucion.OPC_POIV_RES_CONJUNTA': {
  immediate: true,
  handler(nv) {
    if (nv === undefined || nv === null) {
      this.local_ejecucion.OPC_POIV_RES_CONJUNTA = 0;
      return;
    }

    if (this.local_gen.poiv === undefined || this.local_gen.poiv === null) {
      this.local_gen.poiv = 0;
    }
  }
},
     planta_electrolisis: {
      deep: true,
      immediate: true,
      handler(nv) {
        // evita trabajo si no hay cambios relevantes
        if (this._isEqualPE(nv, this.datos)) return;

        this._syncingPE = true;          
        this.datos = { ...nv };          // refrescamos la copia local
        this.$nextTick(() => {           
          this._syncingPE = false;
        });
      }
    },
    
    datos: {
    handler(newVal) {
      this.$emit('update:planta_electrolisis', newVal);
    },
    deep: true
  },
    '$i18n.locale'() {
      
      this.modos_ejecucion = [
        {'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.lcoh_min')},
        {'ID': 2, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.npv_max')},
      ];
      this.selec_meses=[
      { ID: 1,  NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.enero') },
      { ID: 2,  NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.febrero') },
      { ID: 3,  NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.marzo') },
      { ID: 4,  NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.abril') },
      { ID: 5,  NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.mayo') },
      { ID: 6,  NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.junio') },
      { ID: 7,  NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.julio') },
      { ID: 8,  NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.agosto') },
      { ID: 9,  NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.septiembre') },
      { ID: 10, NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.octubre') },
      { ID: 11, NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.noviembre') },
      { ID: 12, NOMBRE: this.$t('simulacion.modulo.ejecucion.opciones.meses.diciembre') },
      ];

      this.opciones_mercado = [
        //{'ID': 0, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.no_limit')},
        {'ID': 0, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.compra_mercado')},
        //{'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.price_limit')},
        //{'ID': 2, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.buy_aux')},
        {'ID': 3, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.off_grid')},
      ];

      this.opciones_bateria = [
        {'ID': 0, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.no_bat')},
        {'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.opt_bat')},
        {'ID': 2, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.bat_fix_cap')},
      ];

      this.opciones_venta_bateria= [
        {'ID': 0, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.no_vbat')},
        {'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.si_vbat')},
        
      ];


      this.opciones_fotovoltaica = [
        {'ID': 0, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.no_pv')},
        {'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.opt_pv')},
        {'ID': 2, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.pv_fix_cap')},
      ];

      this.opciones_eolica = [
        {'ID': 0, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.no_eol')},
        {'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.opt_eol')},
        {'ID': 2, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.eol_fix_cap')},
      ];

      this.headers = [
        { title: this.$t('simulacion.modulo.ejecucion.tabla.ppa'), value: "ppa", align: "start", width: '10%' },
        { title: this.$t('simulacion.modulo.ejecucion.tabla.cppafija'), value: "cppafija", align: "center", width: '20%' },
      ];


      this.opciones_almacenamiento = [
        {'ID': 0, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.no_alm')},
        {'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.opt_alm')},
        {'ID': 2, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.alm_fix')},
      ];

      this.opciones_electrolizador = [
        {'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.opt_elec')},
        {'ID': 0, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.elec_fix')},
      ];

      this.opciones_ppas = [
        {'ID': 0, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.no_ppas')},
        {'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.opt_ppas')},
        {'ID': 2, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.ppas_fix')},
      ];

      this.opciones_poic = [
        { ID: 1, NOMBRE: this.$t('simulacion.modulo.gen.opc_poic_opt') },
        { ID: 0, NOMBRE: this.$t('simulacion.modulo.gen.opc_poic_fix') },
      ];
      


      this.headers_ppa_capmax = [
        { title: this.$t('simulacion.modulo.ejecucion.tabla.ppa'), value: "ppa", align: "start", width: '10%' },
        { title: this.$t('simulacion.modulo.ppa_configuracion.capmax'), value: "capmax", align: "center", width: '20%' },
      ]

    },

    local_ejecucion: {
      handler(newDatos) {        
        this.$emit('update:ejecucion', newDatos);
      },      
      immediate: true,
      deep: true,
    },

    local_datos_generales: {
      handler(newDatos) {
        this.$emit('update:datos_generales', newDatos);
      },
      immediate: true,
      deep: true,
    },

    local_electrolizador: {
      handler(newDatos) {
        this.$emit('update:electrolizador', newDatos);
      },
      immediate: true,
      deep: true,
    },

    local_almacenamiento: {
      handler(newDatos) {
        this.$emit('update:almacenamiento', newDatos);
      },
      immediate: true,
      deep: true,
    },

    local_bateria: {
      handler(newDatos) {
        this.$emit('update:bateria', newDatos);
      },
      immediate: true,
      deep: true,
    },

    local_ppa_configuracion: {
      handler(newDatos) {
        this.$emit('update:ppa_configuracion', newDatos);
      },
      immediate: true,
      deep: true,
    },

    local_gen: {
      handler(newDatos) {
        this.$emit('update:gen', newDatos);
      },
      immediate: true,
      deep: true,
    },

    local_eolica: {
      handler(newDatos) {
        this.$emit('update:eolica', newDatos);
      },
      immediate: true,
      deep: true,
    },

    local_fotovoltaica: {
      handler(newDatos) {
        this.$emit('update:fotovoltaica', newDatos);
      },
      immediate: true,
      deep: true,
    },    
     
  'local_ejecucion.OPC_PCPPAPV'(val) {
    if (val === 1) this.$emit('activar-tab-ppa-venta');
  },
  'local_ejecucion.OPC_PCPPAEOL'(val) {
    if (val === 1) this.$emit('activar-tab-ppa-venta');
  },

  'local_ejecucion.OPC_POIC': {
  immediate: true,
  handler(nv) {
    // Si no venía definido desde el padre, forzamos un valor por defecto
    if (nv === undefined || nv === null) {
      this.local_ejecucion.OPC_POIC = 0; // 0 = Fija (cámbialo a 1 si quieres Optimizar por defecto)
      return;
    }

    // Aseguramos que existan las claves en GEN (reactivas en Vue 3)
    if (this.local_gen.poicmin === undefined) this.local_gen.poicmin = 0;
    if (this.local_gen.poicmax === undefined) this.local_gen.poicmax = 0;
    if (this.local_gen.poicfij === undefined) this.local_gen.poicfij = 0;
    if (this.local_gen.pcpoic  === undefined) this.local_gen.pcpoic  = 0;

    // Alternancia de campos según opción
      if (nv === 1) {
      // Optimizar: forzar valores por defecto
      if (!this.local_gen.poicmin || this.local_gen.poicmin < 0) {
        this.local_gen.poicmin = 0;
      }
      if (!this.local_gen.poicmax || this.local_gen.poicmax <= 0) {
        this.local_gen.poicmax = 150;   
      }
      this.local_gen.poicfij = 0; 
    } else {
      // Fija: limpiar min/max y dejar fijo
      if (!this.local_gen.poicfij || this.local_gen.poicfij <= 0) {
        this.local_gen.poicfij = 0;
      }
      this.local_gen.poicmin = 0;
      this.local_gen.poicmax = 0;
    }
  }
},


'local_ejecucion.OPC_MCDO'(nv) {
  if (nv === 3) {
    this.local_ejecucion.OPC_POIC = 0;
    this.local_gen.poicmin = 0;
    this.local_gen.poicmax = 0;
    this.local_gen.poicfij = 0;
    this.local_gen.pcpoic  = 0;
  } else {
    if (this.local_gen.pcpoic == null) this.local_gen.pcpoic = 0;
    if (this.local_gen.poicmin == null) this.local_gen.poicmin = 0;
    if (this.local_gen.poicmax == null) this.local_gen.poicmax = 0;
    if (this.local_gen.poicfij == null) this.local_gen.poicfij = 0;
  }

  

  },
  'local_ejecucion.OPC_PV': {
    handler() {
      this.resetPoivConjuntaSiNoProcede();
    }
  },
  'local_ejecucion.OPC_EOL': {
    handler() {
      this.resetPoivConjuntaSiNoProcede();
    }
  }

},
  methods: {
    resetPoivConjuntaSiNoProcede() {
    const hayPV = this.local_ejecucion.OPC_PV !== 0;
    const hayEOL = this.local_ejecucion.OPC_EOL !== 0;

    if (!(hayPV && hayEOL)) {
      this.local_ejecucion.OPC_POIV_RES_CONJUNTA = 0;
    }
  },
    actualizarDatos(){
      /* Añadir aqui lo que más haga falta cambiar */
    console.log("Actualizar Datos InputEjec")
    this.local_gen={ ...this.gen}
  },

     // comparación de las claves
    _isEqualPE(a = {}, b = {}) {
      // compara las claves que manipula el UI
      const keys = ['h_ini', 'h_fin', 'sabado_l', 'domingo_l'];
      for (const k of keys) {
        if ((a?.[k] ?? null) !== (b?.[k] ?? null)) return false;
      }
      
      return true;
    },
  
    formatLabel(key) {
      return this.$t('simulacion.modulo.planta_electrolisis.' + key);
    },
    //Funcion para llamar a las funciones que revisan el cambio de año
    calcularAnio(){
      this.recalcularAnioFin();
      console.log("Nuevo fin: ",  this.local_datos_generales.anio_fin )
      
      this.$emit('calcular_anios');
      this.$emit('calcular_hora_final');
      this.$emit('actualizar-an-tot', parseInt(this.anio_ejec_local) || 0);
    
    },
 formatNumber(value) {
    if (value === null || value === undefined || value === '') return '';
    if (typeof value !== 'number') value = Number(value);
    return value.toLocaleString('es-ES', { maximumFractionDigits: 10 });
  },
  updateNumberCampo(obj, field, val, isPercentage = false) {
    const parsed = Number(val.replace(',', '.'));
    const finalValue = isNaN(parsed) ? 0 : (isPercentage ? parsed / 100 : parsed);
    obj[field] = finalValue;
  },
 /*  emitirCambios(){
      console.log("datos nuevos: ", this.local_economicos)
        this.$emit('update:datos_economicos', this.local_economicos);
  }, */
    onCambioDeMercado(){
      
      
      if (this.local_ejecucion.OPC_MCDO === 3)  {
      this.$emit('update:usarConexion', false);
    }

      if (this.local_ejecucion.OPC_MCDO < 3) {

        /* this.opciones_bateria = [
          {'ID': 0, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.no_bat')},
          {'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.opt_bat')},
          {'ID': 2, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.bat_fix_cap')},
        ]; */
        this.local_ejecucion.OPC_UE=1;

      } else {

        //Cuando era off-grid no se podía elegir sin batería
        //Eliminado el 08/10/2025
        /* if (this.local_ejecucion.OPC_BAT == 0){
          this.local_ejecucion.OPC_BAT = 1
        } */

        /* this.opciones_bateria = [        
          {'ID': 1, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.opt_bat')},
          {'ID': 2, 'NOMBRE': this.$t('simulacion.modulo.ejecucion.opciones.bat_fix_cap')},
        ]; */
        this.local_ejecucion.OPC_UE=0;
      }


    },


    emiteCambioAnio() {
      this.$emit('fieldChanged', this.internalValue); 
    },   
    
    
    validarAnio(valor) {
      if (valor < 2025 || valor > 2100) {        
        return 'El año debe estar entre 2025 y 2100';
      }
      return true;
    },

    ajustarRango(campo, min=2025, max=2100) {

      // Ajustar rango general
      if (this.local_datos_generales[campo] < min) {
        this.local_datos_generales[campo] = min;
      } else if (this.local_datos_generales[campo] > max) {
        this.local_datos_generales[campo] = max;
      }
      if (campo === 'anio_inicio') {
       // this.recalcularAnioFin();
        
      } 
    },

    /* Función para revisar que el mes de inicio de la tecnología no supere al mes de inicio si el año COD es el mismo en ambos */
    /*  
    campo será 'eolica' o 'solar'
    */
    ajustarMes(campo) {

      const anio_tec=this.local_datos_generales["anio_inicio_"+campo]
      const mes=this.local_datos_generales["mes_inicio_"+campo]
      const anio_ini=this.local_datos_generales.anio_inicio
      const mes_ini=this.local_datos_generales.mes_inicio
      // Ajustar rango general
      if (anio_tec===anio_ini) {
        if(mes>mes_ini){
          this.local_datos_generales["mes_inicio_"+campo]=mes_ini
        }
      }
          
    },
    handleClickConexion() {
    if (this.local_ejecucion.OPC_MCDO === 3) {
      this.$emit('update:usarConexion', false);
      alert('La conexión eléctrica no está disponible en modo off-grid.');
    }
},
/* Set --> get --> recalcular */
recalcularAnioFin() {
  console.log("RECALCULAR ANIO FIN")
  const inicio = this.local_datos_generales.anio_inicio;
  let fin = inicio + this.anio_ejec_local;
  
  if (this.local_datos_generales.mes_inicio==1){
        fin-=1
      }
      console.log("FIN: ", fin)
  if (fin > 2100) {
    fin = 2100;
    this.anio_ejec_local = 2100 - inicio; 
  }

  this.local_datos_generales.anio_fin = fin;
}



  },
};
</script>

<style scoped>



.small-text-field {
  max-height: 32px; /* Ajusta la altura total */
  font-size: 14px; /* Reduce el tamaño de la fuente */
  padding: 0 8px; /* Ajusta el padding interno */
}

.small-text-field .v-input__control {
  min-height: 32px; /* Ajusta la altura del control */
  line-height: 1.5; /* Ajusta el espaciado del texto */
}
.text-wrap {
  white-space: normal !important;
  text-align: center; 
  line-height: 1.2;   
}
 .same-size {
  height: 65%;
  width: 100%;
} 

.contenedor-personalizado{
  border: 4px solid #bad8f1;
  padding: 30px 15px 10px 15px;
  border-radius: 8px;
  background-color: rgb(241, 247, 252);
}

</style>
